<template>
    <el-card class="box-card">
        <el-form ref="searchForm" :model="searchForm" >
            <el-row :gutter="20">
                <el-col :sm="8" :md="6" :lg="6">
                    <el-form-item label="直播金额(元/分钟):" prop="liveCost" label-width="120px">
                        <el-input-number v-model="searchForm.liveCost"
                                         placeholder="请输入数字" controls-position="right" @change=""
                                        size="medium" ></el-input-number>
                    </el-form-item>
                </el-col>


            </el-row>
            <el-row>
                <el-col :sm="24" :md="12" :lg="6">
                    <el-button type="primary" @click="setSure" >确认</el-button>
                </el-col>
            </el-row>
        </el-form>
    </el-card>

</template>

<script>
    export default {
        name: "index",
        data(){
           return {
               searchForm:{
                   liveCost:'',
                   liveId:''

               }
           }
        },
        created(){
            this.api.user.getLiveConfiguration ()
                    .then(result => {
                        this.searchForm.liveCost = result.data.liveCost;
                        this.searchForm.liveId = result.data.liveId;
                    })
                    .catch(error => {
                        console.log(error);
                    });
        },
        methods:{
            setSure(){
                let param = {
                    liveCost: this.searchForm.liveCost,
                    liveId:this.searchForm.liveId ,
                };
                this.api.user.updateLiveConfiguration(param)
                        .then(result => {
                            console.log(result);
                        })
                        .catch(error => {
                            console.log(error);
                        });
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/videoSet/index.vue